import { O_PROPERTY_INFORMATION_VISITS } from "@/src-refactor/modules/shared/model/const/property/ information-visits.const";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareVisitInfoToClient = (res: IPropertyDetailsResponse) => {
    return {
      visit_type_property:
        res?.visit || res.visit == 0
          ? [O_PROPERTY_INFORMATION_VISITS[res?.visit]]
          : [],
      is_habited_property:
        res?.visit_status === 1 ? [C_YES_AND_NOT.YES] : [C_YES_AND_NOT.NOT]
    };
  };
  
  export default prepareVisitInfoToClient;